import {
  TenantSettingsDtoSchema,
  type TenantSettingsDto,
  type UpdateTenantSettingsRequest,
} from '@ctms/contracts';

import { apiClient } from '../../api/client.js';
import { API_PATHS } from '../../api/paths.js';

/**
 * Site working hours of the signed-in tenant (D4a — feature core-tenant/site-working-hours).
 *
 * The tenant is never sent on the wire: the API reads it from the session, so this
 * client only ever touches the caller's own site. A `null` pair means "full day".
 */
export const tenantsApi = {
  async getSettings(): Promise<TenantSettingsDto> {
    const raw: unknown = await apiClient.get(API_PATHS.tenant.settings).json();
    return TenantSettingsDtoSchema.parse(raw);
  },

  async updateSettings(request: UpdateTenantSettingsRequest): Promise<TenantSettingsDto> {
    const raw: unknown = await apiClient.patch(API_PATHS.tenant.settings, { json: request }).json();
    return TenantSettingsDtoSchema.parse(raw);
  },
};